<template>
  <div class="semester_Score">
    <Header title="学期考试成绩"></Header>
    <div class="semester_Score_top">
      <h3>{{ this.perInfo.name }}-{{ this.perInfo.studentID }}</h3>
      <p>
        专业排名：<b>{{ this.perInfo.zypm }}</b>
      </p>
      <div @click="closeAction()" class="input-tap">
        {{ curSemester }}
        <van-icon name="play"></van-icon>
      </div>
      <ul>
        <li>
          <h3>{{ this.perInfo.xwjd }}</h3>
          <p>学位绩点</p>
        </li>
        <li>
          <h3>{{ this.perInfo.cgjypjcj }}</h3>
          <p>平均成绩</p>
        </li>
        <li>
          <h3>{{ this.perInfo.tyjd }}</h3>
          <p>推优绩点</p>
        </li>
        <li>
          <h3>{{ this.perInfo.typjcj }}</h3>
          <p>推优平均成绩</p>
        </li>
      </ul>
    </div>
    <div class="semester_Score_select">
      <h3>成绩单</h3>
      <div @click="bestPop = true">
        {{ bestOrAll }}
        <van-icon name="play"></van-icon>
      </div>
    </div>
    <div class="semester_Score_table">
      <el-table
        :data="semesterScore"
        style="width:100%;"
        border
        @cell-click="handle"
      >
        <el-table-column
          label="序号"
          width="50"
          type="index"
          sortable
          :sort-method="nameSort"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="courseName"
          label="课程"
          width="100"
          sortable
          :sort-method="nameSort"
          fixed="left"
        ></el-table-column>
        <el-table-column
          prop="kcbh"
          label="课程编号"
          width="125"
          sortable
          :sort-method="nameSort"
        ></el-table-column>
        <el-table-column label="学分" sortable prop="credit" width="90">
          <template slot-scope="scope">
            <span>{{ scope.row.credit }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="curriculumAttributes"
          label="课程属性"
          width="120"
          sortable
          :sort-method="nameSort"
        ></el-table-column>

        <el-table-column label="成绩" sortable prop="fraction" width="90">
          <template slot-scope="scope">
            <span :class="calcBest(scope.row.fraction)">{{
              scope.row.fraction
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <van-popup v-model="popShow" class="popup">
      <h2>{{ this.popList.courseName }}</h2>
      <div>{{ this.popList.fraction }}</div>
      <p>
        课程编号：<span>{{ this.popList.kcbh }}</span>
      </p>
      <p>
        课程属性：<span>{{ this.popList.curriculumAttributes }}</span>
      </p>
      <p>
        课程性质：<span>{{ this.popList.courseNature }}</span>
      </p>
      <p>
        考试性质：<span>{{ this.popList.examinationNature }}</span>
      </p>
      <p>
        成绩等级：<span>{{ this.popList.cjdj }}</span>
      </p>
      <p>
        成绩标识：<span>{{ this.popList.cjbs }}</span>
      </p>
      <p v-if="schoolCode == '12561'">
        通选课类别：<span>{{ this.popList.txklb }}</span>
      </p>
      <p>
        是否及格：<span>{{ this.popList.sfjg }}</span>
      </p>
      <p>
        学分：<span>{{ this.popList.credit }}</span>
      </p>
      <p>
        绩点：<span>{{ this.popList.jd }}</span>
      </p>
      <p v-if="schoolCode == '14621'">
        通选课类别：<span>{{ this.popList.txklb }}</span>
      </p>
      <button @click="closePop()">确定</button>
    </van-popup>
    <van-popup v-model="bestPop" position="bottom">
      <van-picker
        show-toolbar
        :columns="actions1"
        @cancel="bestPop = false"
        @confirm="onSelectBests"
        :item-height="35"
        :default-index="defaultIndex1"
      />
    </van-popup>
    <van-popup v-model="semesterShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="actions"
        @cancel="semesterShow = false"
        @confirm="onSelect"
        :item-height="35"
        :default-index="defaultIndex"
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      bestPop: false,
      defaultIndex: 0,
      bestOrAll: "最好",
      curSemester: "",
      semesterShow: false,
      semesterScore: [],
      actions1: ["最好", "全部", "首次"],
      defaultIndex1: 0,
      perInfo: "",
      popShow: false,
      itemHeight: 33,
      popList: [
        {
          courseName: "",
          fraction: "",
          curriculumAttributes: "",
          courseNature: "",
          examinationNature: "",
          credit: "",
          kcbh: ""
        }
      ],
      actions: [
        {
          values: []
        }
      ],
      type: "1",
      schoolCode: ""
    };
  },
  created() {
    this.getTerm();
    this.semList();
    this.schoolCode = sessionStorage.getItem("schoolCode");
  },
  methods: {
    nameSort(obj1, obj2) {
      let val1 = obj1.courseName.substring(0, 1);
      let val2 = obj2.courseName.substring(0, 1);
      return val1.localeCompare(val2);
    },
    calcBest(e) {
      // if(this.type == 1){
      if (e == "不及格") {
        return "warning-score";
      }
      if (e < 60) {
        return "warning-score";
      }
      // }
    },
    onSelectBests(val) {
      this.bestOrAll = val;
      this.bestPop = false;
      if (val == "最好") {
        this.type = "1";
      } else if (val == "首次") {
        this.type = "0";
      } else {
        this.type = "";
      }
      this.getScore(this.curSemester, this.type);
    },
    async getTerm() {
      const res = await Api.getCurrentTerm();
      this.curSemester = res.data[0].semesterId;
      this.getScore(res.data[0].semesterId, "1");
    },
    async getScore(e, type) {
      const params = {
        semester:e == '全部' ? '' : e,
        // semester: "2023-2024-1",
        type: type
      };
      const res = await Api.getTermGPA(params);
      if (res.data.length == 0) {
        this.$toast("暂无数据~");
      } else {
        this.perInfo = res.data[0];
        this.semesterScore = res.data[0].achievement;
      }
    },
    async semList() {
      let concatList = [];
      const res = await Api.getSemesterList();
      this.semesterList = res.data;
      res.data.forEach((item, index) => {
        concatList[index + 1] = item.semesterId;
        if (item.semesterId == this.curSemester) {
          this.defaultIndex = index + 1;
        }
      });
      concatList[0] = "全部";
      this.actions = concatList;
    },
    closeAction() {
      this.semesterShow = true;
    },
    handle(index) {
      this.popShow = true;
      this.popList = index;
    },
    onSelect(item) {
      this.semesterShow = false;
      this.curSemester = item;
      this.getScore(item, this.type);
    },
    closePop() {
      this.popShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.semester_Score {
  height: 100%;
  padding: 20px 15px 0;
  background-color: #fff;
  .semester_Score_top {
    position: relative;
    height: 158px;
    background: #7469f8;
    box-shadow: 0px 2px 10px 0px rgba(51, 35, 255, 0.35);
    border-radius: 8px;
    margin-bottom: 13px;
    padding: 14px 15px;

    h3 {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: bold;
      margin-bottom: 8px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
      b {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: bold;
        line-height: 22px;
      }
    }
    .input-tap {
      position: absolute;
      width: 107px;
      height: 25px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 13px;
      top: 12px;
      right: 15px;
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 200;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .van-icon {
        transform: rotate(90deg);
      }
    }
    ul {
      width: 100%;
      height: 74px;
      background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.16) 0%,
        rgba(255, 255, 255, 0) 98%
      );
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      li {
        height: 100%;
        flex: 1;
        display: flex;
        align-content: center;
        justify-content: center;
        flex-direction: column;
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          letter-spacing: 0;
          text-align: center;
          font-weight: bold;
          margin-bottom: 3px;
        }
        p {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.8);
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
        }
      }
    }
  }
  .semester_Score_select {
    display: flex;
    justify-content: space-between;
    height: 25px;
    margin-bottom: 14px;
    h3 {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: bold;
    }
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 58px;
      height: 25px;
      background: rgba(116, 105, 248, 0.15);
      border-radius: 13px;
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: right;
      font-weight: 200;
      padding: 0 10px;
      .van-icon {
        transform: rotate(90deg);
      }
    }
  }
  .semester_Score_table {
    border-radius: 6px;
    overflow: auto;
    border: 1px solid #ebeef5 !important;
    max-height: calc(~"100% - 280px");

    /deep/.el-table--border {
      border-radius: 6px;
    }
    /deep/.el-table__header th .cell,
    /deep/.el-table th.el-table__cell {
      background-color: #f2f2f4;
    }
    /deep/.el-table .el-table__cell {
      padding: 0;
    }
    /deep/.el-table td {
      border-bottom: 1px solid #ebeef5 !important;
    }
  }

  .popup button {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
    padding: 11px 0;
    border-radius: 3px;
    width: 100%;
    margin-top: 30px;
  }
  .van-popup.van-popup--center {
    box-sizing: border-box;
    padding: 20px;
    width: 90%;
  }
  .semester_Score .van-popup.van-popup--center > h2 {
    color: @attendance-color-1;
    font-size: 16px;
    line-height: 25px;
    text-align: center;
    font-weight: bold;
  }
  .van-popup.van-popup--center > div {
    color: @attendance-background-color-1;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .van-popup.van-popup--center > p {
    color: @attendance-color-2;
    font-size: 16px;
    line-height: 30px;
  }
  .van-popup.van-popup--center > p > span {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/Score/semester_Score_10294.vue